import React from 'react';
import { Heart, Instagram, Facebook, Twitter } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <div className="footer-logo">
                <Heart className="footer-heart" />
                <h3>Bruna & Lorhan</h3>
              </div>
              <p>
                Obrigado por fazer parte do nosso dia especial. 
                Mal podemos esperar para celebrar com você!
              </p>
              <div className="footer-social">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Instagram />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Facebook />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Twitter />
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Detalhes do Casamento</h4>
              <div className="wedding-details">
                <div className="detail-item">
                  <strong>Data:</strong>
                  <span>13 de Dezembro de 2025</span>
                </div>
                <div className="detail-item">
                  <strong>Horário:</strong>
                  <span>11h00</span>
                </div>
                <div className="detail-item">
                  <strong>Local:</strong>
                  <span>Condomínio Ecogarden Residence</span>
                </div>
                <div className="detail-item">
                  <strong>Código de Vestimenta:</strong>
                  <span>Traje social</span>
                </div>
              </div>
            </div>

            <div className="footer-section">
              <h4>Links Rápidos</h4>
              <ul className="footer-links">
                <li><a href="/">Início</a></li>
                <li><a href="/our-story">Nossa História</a></li>
                <li><a href="/wedding-details">Detalhes</a></li>
                <li><a href="/gallery">Galeria</a></li>
                <li><a href="/presente">Presente</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <p>
              Feito com <Heart className="inline-heart" /> para Bruna & Lorhan
            </p>
            <p className="footer-copyright">
              © 2024 Casamento de Bruna & Lorhan. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
